import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class RegionEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITREGION;
}